import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { QbPostalCodeMultiModule } from '../../components/postal-code-multi/postal-code-multi.module';
// Components across the app
import { HttpClientModule } from '@angular/common/http';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { IonicModule } from '@ionic/angular';
import { PymeInfoPageRoutingModule } from './pyme-info-routing.module';
import { PymeInfoPage } from './pyme-info.page';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PymeInfoPageRoutingModule,
    QbPostalCodeMultiModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    HttpClientModule,
  ],
  declarations: [
    PymeInfoPage,
  ],
  exports: [
    PymeInfoPage,
  ],
})
export class PymeInfoPageModule { }
